import { supabase } from '../client';

export interface OrgAutomationSettings {
  id: string;
  org_id: string;
  auto_shortlist_enabled: boolean;
  auto_shortlist_min_score: number;
  auto_email_on_shortlist: boolean;
  auto_email_sequence_id: string | null;
  auto_email_template_override: string | null;
  auto_interview_on_shortlist: boolean;
  auto_interview_duration_minutes: number;
  auto_advance_on_interview_complete: boolean;
  auto_advance_target_status: string;
  /** Phase 7 — flag stuck applications to reviewers (worker TBD). */
  stuck_stage_enabled: boolean;
  stuck_stage_days: number;
  created_at: string;
  updated_at: string;
}

const DEFAULTS: Omit<OrgAutomationSettings, 'id' | 'org_id' | 'created_at' | 'updated_at'> = {
  auto_shortlist_enabled: false,
  auto_shortlist_min_score: 75,
  auto_email_on_shortlist: false,
  auto_email_sequence_id: null,
  auto_email_template_override: null,
  auto_interview_on_shortlist: false,
  auto_interview_duration_minutes: 30,
  auto_advance_on_interview_complete: false,
  auto_advance_target_status: 'interview_completed',
  stuck_stage_enabled: false,
  stuck_stage_days: 7,
};

export const automationSettingsService = {
  async getForOrg(orgId: string): Promise<OrgAutomationSettings> {
    const { data, error } = await supabase
      .from('ggj_b2b_org_automation_settings')
      .select('*')
      .eq('org_id', orgId)
      .maybeSingle();
    if (error) throw error;
    if (data) {
      return { ...DEFAULTS, ...(data as OrgAutomationSettings) } as OrgAutomationSettings;
    }

    const { data: created, error: createErr } = await supabase
      .from('ggj_b2b_org_automation_settings')
      .insert({ org_id: orgId })
      .select('*')
      .single();
    if (createErr) throw createErr;
    return { ...DEFAULTS, ...(created as OrgAutomationSettings) } as OrgAutomationSettings;
  },

  async update(
    orgId: string,
    patch: Partial<Omit<OrgAutomationSettings, 'id' | 'org_id' | 'created_at' | 'updated_at'>>,
  ): Promise<OrgAutomationSettings> {
    const { data, error } = await supabase
      .from('ggj_b2b_org_automation_settings')
      .update(patch)
      .eq('org_id', orgId)
      .select('*')
      .single();
    if (error) throw error;
    return data as OrgAutomationSettings;
  },

  defaults(): typeof DEFAULTS {
    return { ...DEFAULTS };
  },
};
